import { useMemo } from 'react';

import { useTheme } from '@/providers/ThemeProvider';

export function useChartColors() {
  const { theme } = useTheme();
  return useMemo(() => {
    const cv = (name: string) =>
      getComputedStyle(document.body).getPropertyValue(name).trim();
    return {
      bar: cv('--accent-default'),
      foregroundMuted: cv('--foreground-muted'),
      surface: cv('--surface-default'),
      gridLine: cv('--border-subtle'),
      track: cv('--surface-active'),
      segments: [
        cv('--gray-12'),
        cv('--gray-10'),
        cv('--gray-8'),
        cv('--gray-6'),
        cv('--gray-4'),
      ],
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);
}
